import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

export const LOGO_METALLIC =
  "https://customer-assets.emergentagent.com/job_4f060ec6-080a-4e06-a76e-5e98251f252b/artifacts/4kn53p20_4BD6FDD2-64AA-4D53-9D95-E264ADA34499.png";

// Helper: convert Unsplash URL to WebP + set optimized quality/width
function opt(url, width = 1600) {
  try {
    const u = new URL(url);
    u.searchParams.set("fm", "webp");
    u.searchParams.set("q", "80");
    u.searchParams.set("w", String(width));
    u.searchParams.set("auto", "format");
    return u.toString();
  } catch {
    return url;
  }
}

// Hero background — dark luxury automotive
export const HERO_IMAGE = opt(
  "https://images.unsplash.com/photo-1567808291548-fc3ee04dbcf0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzN8MHwxfHNlYXJjaHwxfHxkYXJrJTIwbHV4dXJ5JTIwY2FyJTIwZ2FyYWdlfGVufDB8fHx8MTc4MzE4OTU4OHww&ixlib=rb-4.1.0&q=85",
  1920
);

export const GALLERY_IMAGES = [
  "https://images.unsplash.com/photo-1658863567312-fcaf9a15bc6f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHwxfHxibGFjayUyMHBvcnNjaGUlMjBzdHVkaW8lMjBsaWdodGluZ3xlbnwwfHx8fDE3ODMxODk1ODh8MA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1597858520171-563a8e8b9925?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHwyfHxibGFjayUyMHBvcnNjaGUlMjBzdHVkaW8lMjBsaWdodGluZ3xlbnwwfHx8fDE3ODMxODk1ODh8MA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1611821064430-0d40291d0f0b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHwzfHxibGFjayUyMHBvcnNjaGUlMjBzdHVkaW8lMjBsaWdodGluZ3xlbnwwfHx8fDE3ODMxODk1ODh8MA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1492144534655-ae79c964c9d7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzN8MHwxfHNlYXJjaHwyfHxkYXJrJTIwbHV4dXJ5JTIwY2FyJTIwZ2FyYWdlfGVufDB8fHx8MTc4MzE4OTU4OHww&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1620584899131-a5ff5f8fbb03?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHwzfHxjYXIlMjBjZXJhbWljJTIwY29hdGluZyUyMGRldGFpbGluZ3xlbnwwfHx8fDE3ODMxODk1ODh8MA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1620584898989-d39f7f9ed1b7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHwyfHxjYXIlMjBjZXJhbWljJTIwY29hdGluZyUyMGRldGFpbGluZ3xlbnwwfHx8fDE3ODMxODk1ODh8MA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1730742298439-6d82f9edc3c2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHwyfHxibGFjayUyMHNwb3J0cyUyMGNhciUyMGhlYWRsaWdodHxlbnwwfHx8fDE3ODMxODk2MDB8MA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1708805283087-cb22474fb88e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwyfHxjYXIlMjBkZXRhaWxpbmclMjBiZWZvcmUlMjBhZnRlcnxlbnwwfHx8fDE3ODMxODk2MDB8MA&ixlib=rb-4.1.0&q=85",
].map((u) => opt(u, 1200));

// Same before/after image pair (before = duller/dirty, after = shiny). We simulate with two similar shots and CSS filter.
export const BEFORE_IMAGE = opt(
  "https://images.unsplash.com/photo-1620584898989-d39f7f9ed1b7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHwyfHxjYXIlMjBjZXJhbWljJTIwY29hdGluZyUyMGRldGFpbGluZ3xlbnwwfHx8fDE3ODMxODk1ODh8MA&ixlib=rb-4.1.0&q=85",
  1600
);
export const AFTER_IMAGE = opt(
  "https://images.unsplash.com/photo-1620584899131-a5ff5f8fbb03?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHwzfHxjYXIlMjBjZXJhbWljJTIwY29hdGluZyUyMGRldGFpbGluZ3xlbnwwfHx8fDE3ODMxODk1ODh8MA&ixlib=rb-4.1.0&q=85",
  1600
);
